import React from 'react'

const Program2 = () => {
  return (
    <div className="program2">
        <div className="program_right_svg">
            <h3 className="h3mb"><span>다른 개발자</span>들이 많이 지원한 포지션</h3>
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="XFteHAoEX_O2i2sztwAI"><path d="M9 16.34l4.58-4.59L9 7.16l1.41-1.41 6 6-6 6z" fillRule="evenodd"></path></svg>
        </div>
        <div className="program2_inner">
            <div className="program2_box b1">
                <div className="program2_box_top">
                    <img alt="블루펫 로고" data-src="https://grepp-programmers.s3.amazonaws.com/production/company/logo/6294/logo.png" data-srcset="" className="" src="https://grepp-programmers.s3.amazonaws.com/production/company/logo/6294/logo.png" srcSet="" />
                    <div className="desc">
                        <span>상시 채용</span>
                        <h3>프론트엔드 개발자</h3>
                        <p>블루펫</p>
                    </div>
                </div>
                <div className="program2_box_bottom">
                    <div className="left">
                        <div>
                            <p>경력</p>
                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="pY422BjfwqK3WqXBw2Wi"><path fill="#fff" fillOpacity=".01" d="M0 0h20v20H0z"></path><path d="M2.722 13.944v-9h14.556v9H2.722z" stroke="#98A8B9"></path><path fillRule="evenodd" clipRule="evenodd" d="M7.778 14.444h4.444l1.111 3.334H6.666l1.112-3.334z" fill="#98A8B9"></path><path fillRule="evenodd" clipRule="evenodd" d="M4.444 16.866c0-.11.09-.2.2-.2h10.711c.11 0 .2.09.2.2v.712a.2.2 0 01-.2.2H4.645a.2.2 0 01-.2-.2v-.712z" fill="#98A8B9"></path></svg>

                        </div>
                        <span>신입가능</span>
                    </div>
                    <div className="line"></div>
                    <div className="right">
                        <div>
                            <p>위치</p>
                            <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="pY422BjfwqK3WqXBw2Wi"><path d="M11.247 11.857s1.864-2.06 1.864-4.446c0-3.419-2.736-6.189-6.111-6.189-3.375 0-6.111 2.77-6.111 6.189 0 2.386 1.864 4.446 1.864 4.446l4.11 4.857a.178.178 0 00.274 0l4.11-4.857v0z" stroke="#98A8B9" strokeMiterlimit="10"></path><path d="M9.778 7.333a2.778 2.778 0 10-5.556 0 2.778 2.778 0 005.556 0z" stroke="#98A8B9" strokeMiterlimit="10"></path></svg>

                        </div>
                        <span>서울 금천구</span>
                    </div>
                </div>
            </div>
            <div className="program2_box b2">
                <div className="program2_box_top">
                    <img alt="히비스 로고" data-src="https://grepp-programmers.s3.amazonaws.com/production/company/logo/2806/Artboard-squre.png" data-srcset="" className="" src="https://grepp-programmers.s3.amazonaws.com/production/company/logo/2806/Artboard-squre.png" srcSet="" />
                    <div className="desc">
                        <span>상시 채용</span>
                        <h3>플랫폼 서비스 개발 팀원</h3>
                        <p>히비스</p>
                    </div>
                </div>
                <div className="program2_box_bottom">
                    <div className="left">
                        <div>
                            <p>경력</p>
                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="pY422BjfwqK3WqXBw2Wi"><path fill="#fff" fillOpacity=".01" d="M0 0h20v20H0z"></path><path d="M2.722 13.944v-9h14.556v9H2.722z" stroke="#98A8B9"></path><path fillRule="evenodd" clipRule="evenodd" d="M7.778 14.444h4.444l1.111 3.334H6.666l1.112-3.334z" fill="#98A8B9"></path><path fillRule="evenodd" clipRule="evenodd" d="M4.444 16.866c0-.11.09-.2.2-.2h10.711c.11 0 .2.09.2.2v.712a.2.2 0 01-.2.2H4.645a.2.2 0 01-.2-.2v-.712z" fill="#98A8B9"></path></svg>

                        </div>
                        <span>신입가능</span>
                    </div>
                    <div className="line"></div>
                    <div className="right">
                        <div>
                            <p>위치</p>
                            <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="pY422BjfwqK3WqXBw2Wi"><path d="M11.247 11.857s1.864-2.06 1.864-4.446c0-3.419-2.736-6.189-6.111-6.189-3.375 0-6.111 2.77-6.111 6.189 0 2.386 1.864 4.446 1.864 4.446l4.11 4.857a.178.178 0 00.274 0l4.11-4.857v0z" stroke="#98A8B9" strokeMiterlimit="10"></path><path d="M9.778 7.333a2.778 2.778 0 10-5.556 0 2.778 2.778 0 005.556 0z" stroke="#98A8B9" strokeMiterlimit="10"></path></svg>

                        </div>
                        <span>서울시 강동구</span>
                    </div>
                </div>
            </div>
            <div className="program2_box b3">
                <div className="program2_box_top">
                    <img alt="블루펫 로고" data-src="https://grepp-programmers.s3.amazonaws.com/production/company/logo/6294/logo.png" data-srcset="" className="" src="https://grepp-programmers.s3.amazonaws.com/production/company/logo/6294/logo.png" srcSet="" />
                    <div className="desc">
                        <span>상시 채용</span>
                        <h3>이러닝 웹 솔루션 개발자</h3>
                        <p>Xinics</p>
                    </div>
                </div>
                <div className="program2_box_bottom">
                    <div className="left">
                        <div>
                            <p>경력</p>
                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="pY422BjfwqK3WqXBw2Wi"><path fill="#fff" fillOpacity=".01" d="M0 0h20v20H0z"></path><path d="M2.722 13.944v-9h14.556v9H2.722z" stroke="#98A8B9"></path><path fillRule="evenodd" clipRule="evenodd" d="M7.778 14.444h4.444l1.111 3.334H6.666l1.112-3.334z" fill="#98A8B9"></path><path fillRule="evenodd" clipRule="evenodd" d="M4.444 16.866c0-.11.09-.2.2-.2h10.711c.11 0 .2.09.2.2v.712a.2.2 0 01-.2.2H4.645a.2.2 0 01-.2-.2v-.712z" fill="#98A8B9"></path></svg>
                        </div>
                        <span>신입가능</span>
                    </div>
                    <div className="line"></div>
                    <div className="right">
                        <div>
                            <p>위치</p>
                            <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="pY422BjfwqK3WqXBw2Wi"><path d="M11.247 11.857s1.864-2.06 1.864-4.446c0-3.419-2.736-6.189-6.111-6.189-3.375 0-6.111 2.77-6.111 6.189 0 2.386 1.864 4.446 1.864 4.446l4.11 4.857a.178.178 0 00.274 0l4.11-4.857v0z" stroke="#98A8B9" strokeMiterlimit="10"></path><path d="M9.778 7.333a2.778 2.778 0 10-5.556 0 2.778 2.778 0 005.556 0z" stroke="#98A8B9" strokeMiterlimit="10"></path></svg>

                        </div>
                        <span>서울특별시 구로구</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Program2
